import { Combobox } from "components/elements";
import { ClientUser } from "@compass/shared/types";

export const UserSelector = ({
    value,
    onChange,
    users,
    className,
    inputClassName,
    withClear,
}: {
    value: number | null | undefined;
    onChange: (value: number | null | undefined) => void;
    users: ClientUser[];
    className?: string;
    inputClassName?: string;
    withClear?: boolean;
}) => {
    const filteredUsers = (query: string) => {
        const queriedUsers =
            query === ""
                ? users
                : users.filter(
                      (user) =>
                          user.firstName?.toLowerCase().includes(query.toLowerCase()) ||
                          user.lastName?.toLowerCase().includes(query.toLowerCase()) ||
                          user.email.toLowerCase().includes(query.toLowerCase()),
                  );

        return queriedUsers.map((user) => ({
            value: user.id,
            display: user.name || user.email,
        }));
    };

    return (
        <Combobox
            placeholder="Select User"
            className={className}
            inputClassName={inputClassName}
            value={value}
            withClear={withClear}
            onChange={onChange}
            displayValue={(id) => {
                const user = users.find((user) => user.id === id);
                return user ? user.name || `${user.firstName} ${user.lastName}` : "";
            }}
            options={filteredUsers}
        />
    );
};
